import { OrderPaymentType } from '../constants/order-payment-type.js';
import { businessDateOfTimestamp } from '../dates/business-day.js';
import { businessDateOfPickedDate } from './business-date-of-picked-date.js';
/** BALANCE_CLEAR's payment_date is an instant (its Pacific day); other types' is a picked day. */
export function businessDateOfOrderPayment(payment) {
    return payment.typeId === OrderPaymentType.BALANCE_CLEAR
        ? businessDateOfTimestamp(payment.paymentDate)
        : businessDateOfPickedDate(payment.paymentDate);
}
//# sourceMappingURL=business-date-of-order-payment.js.map